<template>
  <div class="add-items-to-checklist-wrapper">
    <div ref="addItemsModal" aria-hidden="true" class="modal fade hidden" role="dialog" tabindex='-1'>
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mt-0">{{ $t('checklist.add_to_checklist_modal.title') }}</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <form @submit.prevent="submitItems()" ref="newItemsForm" v-click-outside='closeTagDropdown'>
            <div class="modal-body">
              <div class="relatico-select-wrapper document-types-dropdown">
                <label>{{ userDocumentTypeTitle }}</label>

                <b v-show="docTagParams.length > 0">
                  {{ $t('checklist.add_to_checklist_modal.filtering', { count: docTagParams.length }) }}
                  (<a href="#" @click.prevent="docTagParams = []">
                    {{ $t('checklist.add_to_checklist_modal.show_all') }}
                  </a>)
                </b>

                <div class="float-right tag-dropdown-wrapper">
                  <a @click.prevent='docTagDropdown = true' href='#'>
                    {{ $t('checklist.add_to_checklist_modal.filter') }} <i class="fa fa-filter"></i>
                  </a>

                  <div v-show='docTagDropdown' class="tag-dropdown">
                    <multi-select :getter='getTags' v-model='selectedDocTags' />
                    <div class="actions">
                      <button @click.prevent='docTagDropdown = false' class="btn btn-neutral btn-sm m-r-10">
                        {{ $t('products.list.cancel') }}
                      </button>

                      <button @click.prevent="filterByDocTags" class="btn btn-primary btn-sm">
                        {{ $t('checklist.add_to_checklist_modal.filter_btn') }}
                      </button>
                  </div>
                  </div>
                </div>

                <multi-select ref='docSelect' :getter='getDocumentTypes' v-model='selectedDocTypes' :creator='createDocumentType' />
              </div>

              <div class="relatico-select-wrapper products">
                <label>{{ userProductTitle }}</label>

                <b v-show="productTagParams.length > 0">
                  {{ $t('checklist.add_to_checklist_modal.filtering', { count: productTagParams.length }) }}
                  (<a href="#" @click.prevent="productTagParams = []">
                    {{ $t('checklist.add_to_checklist_modal.show_all') }}
                  </a>)
                </b>

                <div class="float-right tag-dropdown-wrapper">
                  <a @click.prevent='productTagDropdown = true' href='#'>
                    {{ $t('checklist.add_to_checklist_modal.filter') }} <i class="fa fa-filter"></i>
                  </a>

                  <div v-show='productTagDropdown' class="tag-dropdown">
                    <multi-select :getter='getTags' v-model='selectedProductTags' />
                    <div class="actions">
                      <button @click.prevent='productTagDropdown = false' class="btn btn-neutral btn-sm m-r-10">
                        {{ $t('products.list.cancel') }}
                      </button>

                      <button @click.prevent="filterByProductTags" class="btn btn-primary btn-sm">
                        {{ $t('checklist.add_to_checklist_modal.filter_btn') }}
                      </button>
                    </div>
                  </div>
                </div>

                <multi-select ref='prodSelect' :getter='getProducts' v-model='selectedProducts' :creator='createProduct' />
              </div>
              <div class="relatico-select-wrapper">
                <label for='add_multiple'>
                  <input type='checkbox' id='add_multiple' v-model='addToMultiple'/>
                  {{ $t('checklist.add_to_multiple') }}
                </label>

                <div class="add-to-multiple" v-if='addToMultiple'>
                  <label>{{ $t('checklist.select_folder') }}</label>
                  <multi-select :getter='getFolders' v-model='selectedFolders' :template='folderTemplate' />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <input type="submit" name="commit" :value="$t('checklist.add_to_checklist')" class="btn btn-primary"/>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _infinite_multi_select from '../shared/_infinite_multi_select'

  export default {
    components: {
      'multi-select': _infinite_multi_select,
    },
    props: {
      folder: {
        type: Object,
        required: true
      },
      record_id: {},
    },
    data() {
      return {
        selectedFolders: [],
        selectedProducts: [],
        selectedDocTypes: [],
        selectedDocTags: [],
        selectedProductTags: [],
        docTagParams: [],
        productTagParams: [],
        docTagDropdown: false,
        productTagDropdown: false,
        addToMultiple: false,
      }
    },
    computed: {
      productRequestParams() {
        if (this.productTagParams.length == 0)
          return {}
        return { 'filters[tags_id_in]': this.productTagParams }
      },
      documentRequestParams() {
        if (this.docTagParams.length == 0)
          return {}

        return { 'filters[tags_id_in]': this.docTagParams }
      },
    },
    methods: {
      openModal() {
        $(this.$refs.addItemsModal).appendTo("body").modal('show')
      },
      closeModal() {
        $(this.$refs.addItemsModal).modal('hide')
      },
      getTags(params) {
        return this.listStore.getTags(params)
      },
      getFolders(params) {
        return this.listStore.getFolders(params)
      },
      getDocumentTypes(params) {
        return this.listStore.getDocumentTypes(Object.assign({'filters[archive_eq]': false}, this.documentRequestParams, params))
      },
      getProducts(params) {
        return this.listStore.getProducts(Object.assign({'filters[archive_eq]': false}, this.productRequestParams, params))
      },
      createDocumentType(params) {
        return this.store.createDocumentType({ name: params.q })
      },
      createProduct(params) {
        return this.store.createProduct({ name: params.q })
      },
      filterByDocTags() {
        this.docTagParams = this.selectedDocTags.map(t => t.id)
        this.selectedDocTags = []
        this.docTagDropdown = false
        this.$refs.docSelect.open()
      },
      filterByProductTags() {
        this.productTagParams = this.selectedProductTags.map(t => t.id)
        this.selectedProductTags = []
        this.productTagDropdown = false
        this.$refs.prodSelect.open()
      },
      closeTagDropdown() {
        this.docTagDropdown = false
        this.productTagDropdown = false
      },
      submitItems () {
        const isValid = this.selectedProducts.length > 0 && this.selectedDocTypes.length > 0

        if (!isValid) {
          this.$toastr.alert(this.$t('checklist.validate_form_alert'))
          return
        }

        $(this.$refs.newItemFormInput).val('')

        const params = {
          product_ids: this.selectedProducts.map(x => x.id),
          document_type_ids: this.selectedDocTypes.map(x => x.id),
          folder_ids: [this.folder.id].concat(this.selectedFolders.map(f => f.id)),
          record_id: this.record_id,
        }

        this.store.createChecklistItems(params).then(({data}) => {
          this.$emit('update-list')
          this.store.getCurrentUser()
          this.$toastr[data.type](data.message)
          this.closeModal()
          this.selectedProducts = []
          this.selectedDocTypes = []
          this.selectedFolders = []
          this.store.sendMetrics({name: 'add_items_to_checklist', params: this.$route.params, path: this.$route.fullPath})
        })
      },
    }
  }
</script>

<style scoped lang="sass">
  .relatico-select-wrapper
    margin-bottom: 25px
  .modal-body
    min-height: 350px
  .modal-lg
    max-width: 1000px
  .tag-dropdown
    right: 0
    left: auto
    top: 25px
    background-color: #fff
    border: 1px solid #ccc
    border-radius: 3px
    padding: 5px
    position: absolute
    z-index: 20
    width: max-content
    .actions
      text-align: right
  .add-to-multiple
    label
      display: block
  b.float-right
    font-size: 12px
    padding: 5px 15px 0 0
  .custom-select
    max-height: initial
    margin-bottom: 15px
</style>
